/**
 * Jeton d'accès de l'onglet courant, lu par tous les clients HTTP (axios, fetch,
 * middleware OpenAPI, SignalR).
 *
 * Stocké en sessionStorage (propre à chaque onglet), comme la session OIDC
 * d'oidc-client-ts : en localStorage, le dernier onglet rendu imposait son
 * identité à tous les autres (onglet courtier appelant l'API en admin).
 */
const ACCESS_TOKEN_KEY = 'access_token';

export const getAccessToken = (): string | null => {
  try {
    return sessionStorage.getItem(ACCESS_TOKEN_KEY);
  } catch {
    return null;
  }
};

/** N'écrit que si la valeur change (appelé à chaque rendu d'AbpProvider). */
export const setAccessToken = (token: string): void => {
  try {
    if (sessionStorage.getItem(ACCESS_TOKEN_KEY) !== token) {
      sessionStorage.setItem(ACCESS_TOKEN_KEY, token);
      // Ancien emplacement partagé entre onglets : on n'y laisse aucun jeton.
      localStorage.removeItem(ACCESS_TOKEN_KEY);
    }
  } catch {
    // stockage indisponible : les appels partiront sans jeton (401 → renew)
  }
};

export const clearAccessToken = (): void => {
  try {
    sessionStorage.removeItem(ACCESS_TOKEN_KEY);
  } catch {
    // stockage indisponible : rien à effacer
  }
};
